<script context="module">
	export const map = writable(null)
</script>

<script>
	import { onMount, setContext } from 'svelte';
	import { writable} from 'svelte/store'
	import { fade } from 'svelte/transition'
	import { mapbox, key } from './mapbox.js';


	export let height = 300;

	export let lat;
	export let lon;
	export let zoom = 0;
	export let polyline;

	let container;

	let newMap

	onMount(() => {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = 'https://unpkg.com/mapbox-gl/dist/mapbox-gl.css';

		link.onload = () => {
			newMap = new mapbox.Map({
				container,
				style: 'mapbox://styles/mapbox/streets-v11',
				center: [lon, lat],
				zoom
			});

			// newMap.addControl(
			// 	new mapbox.GeolocateControl({
			// 		positionOptions: {
			// 			enableHighAccuracy: true
			// 		},
			// 		trackUserLocation: true
			// 	}),
			// 	'bottom-left'
			// );

			newMap.on("load", function() {
				// Parkway Polyline
				newMap.addLayer({
					id: "route",
					type: "line",
					source: {
						type: "geojson",
						data: {
							type: "Feature",
							properties: {},
							geometry: {
								type: "LineString",
								coordinates: polyline
							}
						}
					},
					layout: {
						"line-join": "round",
						"line-cap": "round"
					},
					paint: {
						"line-color": "#2260A4",
						"line-width": 8
					}
				});
			});

			map.set(newMap)

		};

		document.head.appendChild(link);

		return () => {
			map.remove();
			link.parentNode.removeChild(link);
		};
	});

	$: newMap && newMap.zoomTo(zoom, { duration: 250 });

</script>

<style>
	div {
		/* width: 100vw;
		height: 100vh;
		position: absolute; */
		width: 100%;
		/* height: 1000px; */
	}
</style>

<div bind:this={container} style={`height:${height}px`} in:fade>
	{#if map}
		<slot></slot>
	{/if}
</div>